import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, sectionOf } from "@/lib/api";
import { SocialLinks } from "./SocialLinks";
import { BioButton } from "./BioButton";
import { MemberPhoto } from "./MemberPhoto";
import { Reveal, SectionLabel } from "./Reveal";

const HostCard = ({ m, i }) => (
  <motion.article
    data-testid={`host-card-${i}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
    className="group relative overflow-hidden border border-white/10 bg-[#121216] aspect-[3/4]"
  >
    <MemberPhoto
      src={m.image_url}
      alt={m.name}
      testId={`host-logo-card-${i}`}
      imgClass="grayscale group-hover:grayscale-0 transition-[filter] duration-700"
      glow="bg-[radial-gradient(circle_at_50%_30%,rgba(86,237,74,0.16),transparent_60%)]"
      logoClass="absolute left-1/2 top-[10%] -translate-x-1/2 w-[45%] max-w-[200px] object-contain group-hover:scale-110 group-hover:rotate-[-5deg] transition-transform duration-700"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
    <span className="absolute top-4 left-4 font-mono text-xs uppercase tracking-[0.25em] text-[#56ED4A]">Host · {String(i + 1).padStart(2, "0")}</span>
    <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-300">{m.role}</p>
      <h3 data-testid={`host-name-${i}`} className="font-display uppercase text-4xl md:text-5xl leading-[0.9] mt-1 break-words">{m.name}</h3>
      <div className="mt-4 flex flex-wrap gap-2"><BioButton m={m} testPrefix={`host-${i}`} /><SocialLinks links={m.links} testPrefix={`host-${i}`} /></div>
    </div>
  </motion.article>
);

export const Hosts = () => {
  const [hosts, setHosts] = useState([]);
  useEffect(() => {
    api.get("/members").then((r) => setHosts(Array.isArray(r.data) ? r.data.filter((m) => sectionOf(m) === "host") : [])).catch(() => {});
  }, []);
  return (
    <section id="hosts" data-testid="hosts-section" className="px-5 md:px-10 py-24 md:py-36">
      <Reveal>
        <SectionLabel index="04">The hosts</SectionLabel>
        <h2 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.85] mt-6">On the <span className="chrome-text">mic</span></h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {hosts.map((m, i) => <HostCard key={m.id} m={m} i={i} />)}
        {!hosts.length && (
          <div data-testid="hosts-coming-soon" className="relative overflow-hidden border border-dashed border-white/20 bg-[#121216] aspect-[3/4] grid place-items-center text-center p-8">
            <div>
              <img src="/logo-mark.png" alt="" className="w-28 h-28 mx-auto object-contain opacity-80" />
              <p className="font-display uppercase text-4xl mt-6">Hosts announced soon</p>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 mt-3">Stay locked in</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
